import { Region } from '@hooks/useRegions/types';

export const regionQuestions: Record<string, any> = {
  region: {
    labelKey: 'applicationForm.REGION.region.label',
    options: Object.values(Region).map(region => ({ label: region, value: region })),
  },
};
